import React from 'react'
import { Link, NavLink } from 'react-router-dom';
import * as Icons from 'react-feather';

function SideBarMenu({ menuData, onMenuClick }) {
  const linkStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    gap: '8px'
  };

  const labelStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    flex: 1,
    minWidth: 0
  };

  const arrowStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: '0 0 16px'
  };

  const renderMenu = menuData.map((obj) => {
    const IconComponent = Icons[obj.ImageURL] || Icons.Smartphone; // fallback icon

    return (
      <li className="submenu" key={obj.ModuleId}>
        <Link to="#" style={linkStyle}>
          <span style={labelStyle}>
            <IconComponent size={16} />
            <span>{obj.Name}</span>
          </span>
          <span className="menu-arrow" style={arrowStyle}></span>
        </Link>

        {obj.children && obj.children.length > 0 && (
          <ul>
            {obj.children.map((child) => (
              <li key={child.ModuleId}>
                <NavLink to={child.ActionURL || "#"} onClick={onMenuClick}>
                  {child.Name}
                </NavLink>
              </li>
            ))}
          </ul>
        )}
      </li>
    );
  });

  return <>{renderMenu}</>;
}

export default SideBarMenu;
